import { IStoreState } from 'store';
import { IDeal } from 'store/deals/types';
import { EParetoDealFilter } from 'store/pareto/types';
import { removeUserGroup } from 'lib/helpers/name-formatters';
import { isMatch } from 'store/formula-entry/match';
import { IFieldOption } from 'store/field-options/types';

export const getAvailableRegions = (store: IStoreState): IFieldOption[] => {
  const { fieldOptions } = store;
  const { regions } = fieldOptions;
  if (!regions) {
    return [];
  }
  return regions;
};

export const getAvailableProductLines = (store: IStoreState): IFieldOption[] => {
  const { fieldOptions } = store;
  const { productLines } = fieldOptions;
  if (!productLines) {
    return [];
  }
  return productLines;
};

export const getFilteredDeals = (store: IStoreState): IDeal[] => {
  const { deals: dealState, pareto: paretoState, general: generalState } = store;
  const { data: deals } = dealState;
  const { searchKeyword, dealFilter, regionFilter, productLineFilter } = paretoState;
  const { userIdClaimsName } = generalState;
  const employeeName = removeUserGroup(userIdClaimsName).toLowerCase();

  const fields = ['createdBy', 'customer', 'name'];

  const userOwnedDeals: IDeal[] =
    dealFilter === EParetoDealFilter.ALL
      ? deals
      : deals.filter(deal => {
          const { createdBy } = deal;
          return createdBy && removeUserGroup(createdBy).toLowerCase() === employeeName;
        });

  const filteredDealsByRegion: IDeal[] = userOwnedDeals.filter(deal => {
    if (regionFilter === 'all' || regionFilter === 'global') {
      return deal;
    }
    if (regionFilter === deal.region) {
      return deal;
    }
    return null;
  });

  const filteredDealsByProductLine: IDeal[] = filteredDealsByRegion.filter(deal => {
    if (productLineFilter === 'all' || productLineFilter === 'global') {
      return deal;
    }
    if (productLineFilter === deal.productLine) {
      return deal;
    }
    return null;
  });

  if (!searchKeyword || !dealFilter || !fields) {
    return filteredDealsByProductLine;
  }

  // Combine all field strings into one that can be searched using searchKeyword match function
  const filteredDeals: IDeal[] = filteredDealsByProductLine.filter(deal => {
    const fieldsCombined = fields
      .map(field => {
        return deal[field];
      })
      .join(' ');
    return isMatch(searchKeyword, fieldsCombined);
  });

  return filteredDeals;
};
